import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '4.5rem',
    },
    breadcrumbsContainer: {
      position: 'sticky',
      zIndex: '1000',
      top: '0',
      marginTop: '-16px',
      marginLeft: '-25px',
      marginRight: '-25px',
      paddingLeft: '16px',
    },
    breadcrumbsContainerForUsers: {
      position: 'sticky',
      zIndex: '1000',
      top: '75px',
      marginTop: '-16px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbsContainerForAdmins: {
      position: 'sticky',
      zIndex: '1000',
      top: '1px',
      marginTop: '-28px',
      marginLeft: '-15px',
      marginRight: '-25px',
    },
    breadcrumbItem: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.text.primary,
      padding: '4px 0px',
    },
    activeBreadcrumbItem: {
      color: theme.palette.primary.main,
    },
    breadcrumpIcon: {
      marginRight: '5px',
      fontSize: '18px',
    },
    breadcrumpLabel: {
      fontSize: '14px',
    },
    outerFormContainer: {
      marginBottom: '4rem',
    },
    mainFormContainer: {
      paddingTop: '2rem',
      paddingBottom: '2rem',
      paddingLeft: '1rem',
      marginTop: '1rem',
      paddingRight: '1.5rem',
    },
    formLabelContainer: {
      marginTop: '8px',
      marginBottom: '10px',
    },
    formLabel: {
      fontSize: '1.6rem',
    },
    formFooterOuterContainer: {
      zIndex: '1000',
      position: 'fixed',
      bottom: '0',
      width: '100%',
      left: '0',
    },
    formFooterContainer: {
      height: '60px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: '1.5rem',
    },
    saveButton: {
      marginLeft: '1rem',
    },
  };
});
